import { useTracking } from 'react-tracking';
import { RouterLink } from '@redux-first-router-link';
import {
  CompetitorWrapper,
  CompetitorDetails,
  CompetitorContent,
  SnowflakeSkeleton,
} from './styled';
import loadable from '@loadable/component';
const Snowflake = loadable(() => import('@components/Snowflake/Snowflake'), {
  fallback: (
    <SnowflakeSkeleton>
      <div />
    </SnowflakeSkeleton>
  ),
});

export interface CompetitorProps {
  points: number[];
  index: number;
  companyId: string;
  uniqueSymbol: string;
  companyName: string;
  canonicalUrl: string;
  marketCap: string;
}
export default function Competitor({
  index,
  points,
  companyId,
  companyName,
  uniqueSymbol,
  marketCap,
  canonicalUrl,
}: CompetitorProps) {
  const { trackEvent } = useTracking();

  return (
    <CompetitorWrapper data-cy-id={`competitor-${index}`}>
      <RouterLink
        inheritColor
        noUnderline
        to={canonicalUrl}
        onClick={() =>
          trackEvent({
            action: 'click',
            index,
            uniqueSymbol,
            companyId,
          })
        }
      >
        <CompetitorContent>
          <Snowflake points={points} />
          <CompetitorDetails>
            <p>{companyName}</p>
            <h4>{uniqueSymbol}</h4>
            <h5>{marketCap}</h5>
          </CompetitorDetails>
        </CompetitorContent>
      </RouterLink>
    </CompetitorWrapper>
  );
}
